import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo
} from 'react';
import PropTypes from 'prop-types';

const NavigationContext = createContext();

export const useNavigation = () => useContext(NavigationContext);
export function NavigationProvider({ children }) {
  const [navigationItems, setNavigationItems] = useState([]);

  useEffect(() => {
    const fetchNavigationItems = async () => {
      const response = await fetch(`/navigation/menu/service/`);
      const data = await response.json();
      if (data?.service) {
        setNavigationItems(data.service);
      }
    };
    fetchNavigationItems();
  }, []);

  const navigationValue = useMemo(
    () => ({ navigationItems, setNavigationItems }),
    [navigationItems, setNavigationItems]
  );

  return (
    <NavigationContext.Provider value={navigationValue}>
      {children}
    </NavigationContext.Provider>
  );
}

NavigationProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default NavigationContext;
